const INITIAL_STATE = { offices: [] };

const officesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_OFFICES":
      return { ...state, offices: [...action.payload] };
    case "UPLOAD_OFFICE":
      return {
        ...state,
        offices: [action.payload, ...state.offices],
      };
    case "UPDATE_OFFICE":
      const filteredOfficeArray = state.offices.filter(
        (office) => office.officeId !== action.payload.officeId
      );

      return {
        ...state,
        offices: [...filteredOfficeArray, action.payload],
      };
    case "DELETE_OFFICE":
      const updatedofficeArray = state.offices.filter(
        (office) => office.officeId !== action.payload
      );
      return {
        ...state,
        offices: [...updatedofficeArray],
      };
    default:
      return { ...state };
  }
};
export default officesReducer;
